export default __webpack_public_path__ + "static/media/warning.2ba18003.svg";